import cn from "classnames";
import PanelTemplate from "components/shared/profile/panel";
import { noRolesOtherThan } from "helpers/roles";
import React from "react";
import { purgeOtherSessions } from "sources/account";
import { config, initialState } from "./config";
import TwoFaSettings from "./twoFaSettings";

class PersonalInfo extends PanelTemplate {
    toggleTwoFaModal = () => {
        this.props.modal({
            name: "default",
            title: this.props.data.twoFactorProvider
                ? "Отключение двухфакторной аутентификации"
                : "Включение двухфакторной аутентификации",
            windowMod: "sm",
            CustomBody: TwoFaSettings,
            bodyData: {
                data: this.props.data,
                refreshProfile: this.props.update,
            },
        });
    };

    purgeOtherSessions = () => {
        this.props.modal({
            name: "confirm",
            title: "Вы уверены, что хотите выйти со всех устройств кроме текущего?",
            buttons: { confirm: "Да", cancel: "Нет" },
            action: () => purgeOtherSessions().then(() => this.props.update()),
        });
    };

    renderBody = () => {
        const { firstName, lastName, patronymic, email, phoneNumber, phoneNumberExtension } = this.props.config;
        const { twoFactorProvider } = this.props.data;

        const showToFa = noRolesOtherThan(this.props.roles, [
            "isTruckingOrganizationAdmin",
            "isTruckingOrganizationHeadLogist",
            "isTruckingOrganizationManager",
            "isTruckingOrganizationOperator",
            "isTruckingOrganizationViewer",
            "isTruckingOrganizationDispatcher",
            "isTruckingOrganizationExtendedViewer",
        ]);

        return (
            <div className="row">
                <div className="col-sm-4">
                    <h5>Персональные данные</h5>
                </div>
                <div className="col-sm-8">
                    {this.renderField(lastName)}
                    {this.renderField(firstName)}
                    {this.renderField(patronymic)}
                    {this.renderField(email)}
                    <div>
                        <div className="w-75 d-inline-block pr-3">{this.renderField(phoneNumber)}</div>
                        <div className="w-25 d-inline-block">{this.renderField(phoneNumberExtension)}</div>
                    </div>
                    <div className="mb-3">
                        {showToFa && (
                            <div
                                className={cn("btn btn-xs mr-2", {
                                    "btn-secondary": !twoFactorProvider,
                                    "btn-outline-danger": twoFactorProvider,
                                })}
                                onClick={this.toggleTwoFaModal}
                            >
                                {twoFactorProvider ? "Отключить" : "Включить"} двухфакторную аутентификацию
                            </div>
                        )}
                        <div className="btn btn-xs btn-danger" onClick={this.purgeOtherSessions}>
                            Выйти со всех устройств кроме текущего
                        </div>
                    </div>
                </div>
            </div>
        );
    };
}

const ConfiguredPanel = (props) => <PersonalInfo {...props} config={config} initialState={initialState} />;

export default ConfiguredPanel;
